var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ico_17_home2_px24",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    id: "Path_2167",
    "data-name": "Path 2167",
    d: "M369.878,846.77l-10.228-10.824-.686-.726a.8.8,0,0,0-1.176,0l-10.914,11.55a1.808,1.808,0,0,0-.373.592,1.9,1.9,0,0,0-.125.7,1.674,1.674,0,0,0,1.718,1.674h1.125v9.23h18.313v-9.23h1.15a1.549,1.549,0,0,0,1.2-.427,1.77,1.77,0,0,0,.368-.582,1.891,1.891,0,0,0,.128-.686A1.843,1.843,0,0,0,369.878,846.77Zm-10.019,10.573h-2.965v-6.116h2.965Zm5.768-9.528v9.528h-4.074v-6.789a1.091,1.091,0,0,0-1.059-1.121h-4.235a1.09,1.09,0,0,0-1.058,1.121v6.789h-4.074v-9.528h-2.541l9.795-10.361.611.647,9.18,9.714Z",
    transform: "translate(-346.376 -834.963)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/Home.f28514bdf58cf3d4309242ab165995a1.svg";
export { ForwardRef as ReactComponent };